import { useExamEventDetails } from '@exam-center/exam-event-management';
import { ExamEventStatus } from '@exam-center/graphql';
import { Flex, Paper } from '@shared/components';

import { EmptyExamEventResultSection } from '../empty-exam-event-result-section';
import { ExamEventExamineeResultSection } from '../exam-event-examinee-result-section';
import { ExamEventProctorSection } from '../exam-event-proctor-section';
import { ExamEventResultSummary } from '../exam-event-result-summary';

export default function ExamEventResultSection() {
  const {
    examEvent: {
      status: examEventStatus,
      metadata: { examGradingStatus },
    },
  } = useExamEventDetails();

  if ([ExamEventStatus.Completed, ExamEventStatus.Canceled].includes(examEventStatus)) {
    return (
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
        <ExamEventResultSummary />
        <ExamEventProctorSection />
        <ExamEventExamineeResultSection />
      </Flex>
    );
  }

  if (examEventStatus === ExamEventStatus.InProgress && examGradingStatus) {
    return (
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
        <ExamEventResultSummary />
        <ExamEventProctorSection />
        <ExamEventExamineeResultSection />
      </Flex>
    );
  }

  return (
    <Paper
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        height: '100%',
      })}
    >
      <EmptyExamEventResultSection />;
    </Paper>
  );
}
